@if (isExistingIssueEditModalVisible) {
  <div id="newIssueEdit">
    <div class="modal-overlay">
      <div
        #existingIssueEditModal
        class="modal-container"
        [style.left.px]="issuePositionX"
        [style.top.px]="issuePositionY"
      >
        <!-- MODAL HEADER -->
        <div class="modal-header" (mousedown)="startIssueDrag($event)">
          <h5 class="modal-title">{{ title }}</h5>
          <div class="d-flex gap-2 actionColumn">
            <!-- SAVE Records -->
            <button
              type="button"
              class="btn btn-link p-0 successIcon iconCSS"
              (click)="saveRecord()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="25"
                height="25"
                fill="none"
                stroke="#0b2d71"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <title>Save Records</title>
                <path d="M6 4h9l3 3v12H6z" />
                <path d="M9 4v5h6V4" />
                <path d="M9 14l2 2 4-4" />
              </svg>
            </button>

            <!-- Close Form -->
            <button type="button" class="btn btn-link p-0 dangerIcon iconCSS" (click)="close()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                fill="none"
                stroke="#000"
                stroke-width="2.4"
                stroke-linecap="round"
              >
                <title>Close Audit</title>
                <path d="M6 6L18 18" />
                <path d="M18 6L6 18" />
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-body p-5">
          <app-existing-issue-content
            #existingIssueContent
            [action]="'view'"
            [existingIssueForm]="existingIssueForm"
            [isSaveVisible]="false"
            [mode]="'record-edit'"
          >
          </app-existing-issue-content>
        </div>
      </div>
    </div>
  </div>
}
